import { useReducer, useEffect } from "react";
import logListReducer, { initialState } from "./reducer";
import { fetchLogList } from "./api";
import ACTIONS from "./actions";

async function getLogListDetails(dispatch, chargerId) {
  dispatch({ type: ACTIONS.FETCH_LOG_LIST_INIT });
  try {
    // Extract serialNumber if chargerId contains refresh trigger (format: serialNumber_refreshTrigger)
    // Check if chargerId ends with underscore followed by digits (refresh trigger)
    let actualChargerId = chargerId;
    if (chargerId && typeof chargerId === "string") {
      const match = chargerId.match(/^(.+)_(\d+)$/);
      // If it matches the pattern and the last part looks like a refresh trigger (numeric), extract serialNumber
      if (match && match[2]) {
        actualChargerId = match[1];
      }
    }
    const logListData = await fetchLogList(actualChargerId);
    if (logListData) {
      dispatch({ type: ACTIONS.FETCH_LOG_LIST_SUCCESS, payload: logListData?.data });
    } else {
      dispatch({ type: ACTIONS.FETCH_LOG_LIST_FAILURE });
    }
  } catch (error) {
    dispatch({ type: ACTIONS.FETCH_LOG_LIST_FAILURE });
  }
}

function useLogListReducer(chargerId) {
  const [state, dispatch] = useReducer(logListReducer, initialState);

  useEffect(() => {
    if (chargerId) {
      getLogListDetails(dispatch, chargerId);
    }
  }, [chargerId]);

  return {
    state,
  };
}

export default useLogListReducer;
